import dummyToggle from 'bloko/common/collection/dummyToggle';
/**
 * Создаёт переключатель элементов в наборе с учётом иерархии элементов:
 * — если выбран или сброшен родитель, выбираются или сбрасываются все его потомки;
 * — если выбраны все потомки родителя, выбирается и родитель;
 * — если сброшен хотя бы один потомок выбранного родителя, сбрасывается и родитель.
 * @returns {SetToggler}
 * @constructor
 */
function createTreeCollectionToggler(collection) {
    /**
     * Определение состояния по дочерним элементам.
     * @param {Set} set
     * @param {String} id
     * @returns {Boolean}
     * @private
     */
    function _getCumulativeParentState(set, id) {
        return collection.getChildren(id).every((model) => {
            return set.has(model.id);
        });
    }

    /**
     * Простановка состояния всем дочерним элементам.
     * @param {Set} set
     * @param {String} id
     * @param {Boolean} state
     * @private
     */
    function _setStateForAllChildren(set, id, state) {
        collection.walkChildren(id, (model) => {
            dummyToggle(set, model.id, state);
        });
    }

    /**
     * Переключение состояния модели, её родителей и потомков.
     * @type {SetToggler}
     */
    function toggle(set, id, state) {
        if (dummyToggle(set, id, state)) {
            collection.walkParents(id, (parent) => {
                dummyToggle(set, parent.id, _getCumulativeParentState(set, parent.id));
            });
        }
        _setStateForAllChildren(set, id, state);
    }

    return toggle;
}

export default createTreeCollectionToggler;
